<mat-dialog-content>
  <div fxLayout="column" fxLayoutGap="8px">
    <div
      *ngFor="let entry of entries$ | async; let last = last; trackBy: trackId"
      [class.brd-b]="!last"
      class="py-2"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px"
    >
      <div fxLayout="column" fxLayoutGap="4px">
        <div class="mat-typography">{{ entry.name | truncate: 100 }}</div>
        <div fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="mat-button-small" (click)="removeFromHidden(entry.id)">
            {{ 'feed.removeHidden' | translate }}
          </button>
        </div>
      </div>
      <div style="height: 32px; width: 32px" class="!ml-auto">
        <img *ngIf="entry.iconUrl != null; else msIcon" [src]="entry.iconUrl" class="h-full" />
        <ng-template #msIcon>
          <ms-icon style="font-size: 32px" class="h-full" [icon]="entry.icon"> </ms-icon>
        </ng-template>
      </div>
    </div>
  </div>
</mat-dialog-content>
